export const tableStatusBtns = [
  {
    label: 'На согласовании спп',
    code: ['on_approval']
  },
  {
    label: 'Все'
  }
]
